class exports.Filter
    init: (type, value, title, special, parent) ->
        @type = type
        @value = value
        @title = title
        @special = special
        @visible = false
        @active = true
        @selector = ''
        @parent = parent

    showSelf: () ->
        ths = this
        ths.visible = true
        sel = '<span class="applied_filter" data-value="' + ths.value + '">' + ths.title
        if ths.type isnt 'status_applied_filter' and ths.type isnt 'type_applied_filter'
            sel += '<i class="fa fa-remove pull-right"></i>'
        sel += '<br></span>'
        ths.selector = $(sel)

        $('.' + ths.type).append(ths.selector)

        ths.selector.children('i.fa fa-remove').bind 'click', () ->
            ths.destroySelf()


    destroySelf: (removeFromArray = true) ->
        ths = this
        ths.selector.fadeOut()
        ths.selector.remove()
        if removeFromArray
            ths.parent.filters.splice($.inArray(ths, ths.parent.filters), 1)
            ths.parent.updateFilters()

        aimChevronRight = 1
        for filter in ths.parent.filters
            if filter.type is ths.type
                aimChevronRight = 0
                break
        if aimChevronRight
            $('.' + ths.type).children('i').removeClass('fa fa-chevron-down').addClass('fa fa-chevron-right')

    hideSelf: () ->
        ths = this
        ths.selector.fadeOut()
        ths.active  = false
        ths.visible = false

    revealSelf: () ->
        ths = this
        ths.selector.fadeIn()
        ths.active  = true
        ths.visible = true
